import { useQuery } from '@tanstack/react-query';

import { SeasonDivisionSettings } from '@/entities/season-division/SeasonDivisionPool';
import { seasonDivisionPoolKeys } from '@/hooks/leagueSeasonDivision/seasonDivisionPoolKeys';
import { getSeasonDivisionSettings } from '@/infrastructure/network/data/season-divisions/season-division-settings';

export const useSeasonDivisionSettings = (poolUuid: string) => {
	return useQuery<SeasonDivisionSettings>({
		queryKey: seasonDivisionPoolKeys.pool(poolUuid),
		queryFn: async () => {
			const response = await getSeasonDivisionSettings({ poolUuid });
			return response.data;
		},
		enabled: !!poolUuid
	});
};
